import { createTheme } from "@mui/material";

const theme = createTheme({
    colors: {
        primary: '#527D97',
        secondary: '#8BC83F',
        background: '#527D97',
        text: '#ffffff',
        opacity: '#234F68'
    },
    fontSizes: {
        small: '0.8rem',
        medium: '1rem',
        large: '1.5rem'
    }
});

export default theme;
